import i18n from '@/i18n'

export default [
  {
    path: '/reporting-overview',
    name: 'reportingOverview',
    component: () => import(/* webpackChunkName: "Reporting" */ '@/components/Reporting/Overview/ReportingOverview.vue'),
    meta: {
      noContextRequired: true
    }
  },
  {
    path: '/reporting',
    component: () => import(/* webpackChunkName: "Reporting" */ '@/views/Reporting.vue'),
    meta: {
      permissions: ['Mapi.MerchantAccountGroups.Read'],
      menu: {
        index: 40,
        activeWhen: ['businessAccount', 'tradingAccount', 'reserveAccount', 'securityAccount', 'remittanceAccount', 'invoiceAccount', 'costStatement', 'batchOverviewReport', 'batchDetailReport'],
        title: i18n.t('label.reporting'),
        icon: ['fal', 'receipt'],
        hasSelectedContext: ['business']
      }
    },
    children: [
      {
        path: 'business-account/:accountNumber?',
        name: 'businessAccount',
        component: () => import(/* webpackChunkName: "Reporting" */ '@/components/Reporting/Overview/ReportingbusinessAccountOverview.vue'),
        meta: {
          permissions: ['Mapi.BagsExternal.Read'],
          page: {
            title: i18n.t('reporting.reportType.types.businessAccount.title'),
            fullWidth: true
          },
          menu: {
            routeName: 'businessAccount',
            activeWhen: ['businessAccount'],
            title: i18n.t('reporting.reportType.types.businessAccount.title'),
            hasSelectedContext: ['business']
          }
        },
        props: (route) => ({ account: 'current', ...route.params })
      },
      {
        path: 'trading-account/:accountNumber?',
        name: 'tradingAccount',
        component: () => import(/* webpackChunkName: "Reporting" */ '@/components/Reporting/Overview/ReportingTradingAccountOverview.vue'),
        meta: {
          permissions: ['Mapi.MerchantAccountGroups.Read'],
          page: {
            title: i18n.t('reporting.reportType.types.tradingAccount.title'),
            fullWidth: true
          },
          menu: {
            routeName: 'tradingAccount',
            activeWhen: ['tradingAccount'],
            title: i18n.t('reporting.reportType.types.tradingAccount.title'),
            hasSelectedContext: ['business', 'merchant']
          }
        },
        props: (route) => ({ account: 'trading', ...route.params })
      },
      {
        path: 'reserve-account/:accountNumber?',
        name: 'reserveAccount',
        component: () => import(/* webpackChunkName: "Reporting" */ '@/components/Reporting/Overview/ReportingReserveAccountOverview.vue'),
        meta: {
          permissions: ['Mapi.MerchantAccountGroups.Read'],
          page: {
            title: i18n.t('reporting.reportType.types.reserveAccount.title'),
            fullWidth: true
          },
          menu: {
            routeName: 'reserveAccount',
            activeWhen: ['reserveAccount'],
            title: i18n.t('reporting.reportType.types.reserveAccount.title'),
            hasSelectedContext: ['business', 'merchant']
          }
        },
        props: (route) => ({ account: 'reserves', ...route.params })
      },
      {
        path: 'security-account/:accountNumber?',
        name: 'securityAccount',
        component: () => import(/* webpackChunkName: "Reporting" */ '@/components/Reporting/Overview/ReportingSecurityAccountOverview.vue'),
        meta: {
          permissions: ['Mapi.MerchantAccountGroups.Read'],
          page: {
            title: i18n.t('reporting.reportType.types.securityAccount.title'),
            fullWidth: true
          },
          menu: {
            routeName: 'securityAccount',
            activeWhen: ['securityAccount'],
            title: i18n.t('reporting.reportType.types.securityAccount.title'),
            hasSelectedContext: ['business', 'merchant']
          }
        },
        props: (route) => ({ account: 'security', ...route.params })
      },
      {
        path: 'remittance-account/:accountNumber?',
        name: 'remittanceAccount',
        component: () => import(/* webpackChunkName: "Reporting" */ '@/components/Reporting/Overview/ReportingRemittanceAccountOverview.vue'),
        meta: {
          permissions: ['Mapi.InternalMerchantAccounts.Read'],
          page: {
            title: i18n.t('reporting.reportType.types.remittanceAccount.title'),
            fullWidth: true
          },
          menu: {
            routeName: 'remittanceAccount',
            activeWhen: ['remittanceAccount'],
            title: i18n.t('reporting.reportType.types.remittanceAccount.title'),
            // canShow: ({ business }) => business !== null && !business.camAutoRemittance,
            hasSelectedContext: ['business', 'merchant']
          }
        },
        props: (route) => ({ account: 'remittance', ...route.params })
      },
      {
        path: 'invoice-account/:accountNumber?',
        name: 'invoiceAccount',
        component: () => import(/* webpackChunkName: "Reporting" */ '@/components/Reporting/Overview/ReportingInvoiceAccountOverview.vue'),
        meta: {
          permissions: ['Mapi.InternalMerchantAccounts.Read'],
          page: {
            title: i18n.t('reporting.reportType.types.invoiceAccount.title'),
            fullWidth: true
          },
          menu: {
            routeName: 'invoiceAccount',
            activeWhen: ['invoiceAccount'],
            title: i18n.t('reporting.reportType.types.invoiceAccount.title'),
            canShow: ({ merchant }) => merchant !== null && merchant.grossSettlement,
            hasSelectedContext: ['business', 'merchant']
          }
        },
        props: (route) => ({ account: 'invoice', ...route.params })
      },
      {
        path: 'cost-statement/:accountNumber?',
        name: 'costStatement',
        component: () => import(/* webpackChunkName: "Reporting" */ '@/components/Reporting/Overview/ReportingCostStatementOverview.vue'),
        meta: {
          permissions: ['Mapi.MerchantAccountGroups.Read'],
          page: {
            title: i18n.t('reporting.reportType.types.costStatement.title'),
            fullWidth: true
          },
          menu: {
            routeName: 'costStatement',
            activeWhen: ['costStatement'],
            title: i18n.t('reporting.reportType.types.costStatement.title'),
            hasSelectedContext: ['business', 'merchant']
          }
        },
        props: true
      },
      {
        path: 'batch-report/:accountNumber?',
        name: 'batchOverviewReport',
        component: () => import(/* webpackChunkName: "Reporting" */ '@/components/Reporting/Overview/ReportingBatchOverviewReport.vue'),
        meta: {
          permissions: ['Mapi.MerchantAccountGroups.Read'],
          page: {
            title: i18n.t('reporting.reportType.types.batchOverviewReport.title'),
            fullWidth: false
          },
          menu: {
            routeName: 'batchOverviewReport',
            activeWhen: ['batchOverviewReport', 'batchDetailReport'],
            title: i18n.t('reporting.reportType.types.batchOverviewReport.title'),
            hasSelectedContext: ['business', 'merchant']
          }
        },
        props: true
      },
      {
        path: 'batch-report/:accountNumber/batch/:batchId',
        name: 'batchDetailReport',
        component: () => import(/* webpackChunkName: "Reporting" */ '@/components/Reporting/Detail/ReportingBatchDetailReport.vue'),
        meta: {
          permissions: ['Mapi.MerchantAccountGroups.Read'],
          page: {
            title: i18n.t('reporting.reportType.types.batchDetailReport.title'),
            fullWidth: true
          }
        },
        props: true
      }
    ]
  }
]
